
//files wrong but not used on product page.
var strokeImages8lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-1.png?v=1726013090", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-1_289b19a4-d9e5-40b2-ba12-af175f4c2968.pdf?v=1726165292" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-2.png?v=1726013090", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-2_4222854c-5f85-475d-9a6c-d98154431641.pdf?v=1726165292" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-3.png?v=1726013090", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-3_0e3116eb-5931-4e6b-8f67-b53e7c9bb079.pdf?v=1726165292" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-4.png?v=1726013090", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-4_4bb77907-1895-46a9-be71-1237bc11be3f.pdf?v=1726165292" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-5.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-5_be06f1f5-05f1-405e-9389-868f02d0d2ff.pdf?v=1726165292" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-6.png?v=1726014279", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-6_a76fc29c-5210-4114-917a-8de6ff40e6a5.pdf?v=1726165292" },
    "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-7.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-7_714a9891-5851-47d0-9f85-7b1798ec42a4.pdf?v=1726165292" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-8.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-8-12-8_9ba24df5-222e-4ae1-a125-2c1c67d56514.pdf?v=1726165292" }
  };
  var strokeImages16lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-1.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-1_f4a89d8c-8e72-4bf5-bc7b-d5bd54031c69.pdf?v=1726165309" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-2.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-2_9a83755e-a4c6-4daa-be6f-7fe6fa453fbb.pdf?v=1726165309" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-3.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-3_04407a64-5081-4565-8b89-2f22ed93dea6.pdf?v=1726165309" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-4.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-4_31029ef0-eefd-4457-b334-523dd48b67de.pdf?v=1726165309" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-5.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-5_1332875f-d773-4831-b70b-25a325f116b8.pdf?v=1726165309" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-6.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-6_6f7bd498-4fab-4fa9-b105-ee9ac7b8f84a.pdf?v=1726165310" },
    "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-7.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-7_f10fd7a3-187b-4247-a03f-c571fb7bcbed.pdf?v=1726165309" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-8.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-16-12-8_7c7c3368-15b1-4c95-9eb2-0044c5e37f32.pdf?v=1726165309" }
  };
  var strokeImages38lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-1.png?v=1726014278%20", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-1_660103d8-8023-4fd2-8a99-e6459f38c72f.pdf?v=1726165323" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-2.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-2_79cc9120-c417-42b4-9876-04a43ab834bd.pdf?v=1726165323" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-3.png?v=1726014279%20", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-3_d6bbc597-3fb0-469c-b99d-8da7d91f8ef3.pdf?v=1726165323" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-4.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-4_f3a9d6f0-f09a-446b-8512-0b3347a2fdff.pdf?v=1726165323" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-5.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-5_f61bbea9-3105-4e94-8160-17f4eec03457.pdf?v=1726165323" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-6.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-6_f81b55d2-4459-4d5b-bffa-7b68b12b997b.pdf?v=1726165323" },
    "7": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-7.png?v=1726014279", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-7_9b472272-5fd3-4c84-9e8b-cba912a6e9d8.pdf?v=1726165323" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-8.png?v=1726014278", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-MU-38-12-8_dd394b2a-13b6-473e-9445-33fd95a09994.pdf?v=1726165323" }
  };
  
  
  jQuery(document).ready(function ($) {
  var strokeSelector = document.getElementById("strokeSelector");
  var forceSelector = document.getElementById("forceSelector");
  var strokeImage = document.getElementById("strokeImage");
  var imageLink = document.getElementById("imageLink");

  
  function updateImage() {
    var stroke = strokeSelector.value;
    var force = forceSelector.value;
    var selectedMap;
    if (force === "8") {
      selectedMap = strokeImages8lb;
    } else if (force === "16") {
      selectedMap = strokeImages16lb;
    } else if (force === "38") {
      selectedMap = strokeImages38lb;
    }

    if (selectedMap[stroke]) {
      strokeImage.src = selectedMap[stroke].img;
      imageLink.href = selectedMap[stroke].link;
    }
  }
  function preloadImages(map) {
    Object.values(map).forEach(entry => {
      const img = new Image();
      img.src = entry.img;
    });
  }
  window.addEventListener('load', () => {
    setTimeout(() => {
      preloadImages(strokeImages8lb);
      preloadImages(strokeImages16lb);
      preloadImages(strokeImages38lb);
    }, 500);
  });
  
  strokeSelector?.addEventListener("change", updateImage);
  forceSelector?.addEventListener("change", updateImage);
  




  function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }
  // Product tab toggle
  let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
  document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
    radio.addEventListener("click", function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
      } else {
        lastChecked = this;
      }
    });
  });

    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    
    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }

    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();

  });
